import { Mutation } from "@apollo/client/react/components";
import { FORM_ERROR } from "final-form";
import { useRouter } from "next/router";
import React from "react";
import { useIntl } from "react-intl";
import { refetchQueries } from "~/lib/apollo/RefetchQueriesFixLink";
import CreateGroup from "~/lib/mutations/CreateGroup";
import {
  ICreateGroupMutation,
  ICreateGroupMutationVariables,
} from "~/lib/mutations/__generated__/CreateGroup.generated";
import { IVendorQuery } from "~/lib/queries/__generated__/VendorQuery.generated";
import GroupForm from "~/components/group/GroupForm";
import { convertValuesToVariables } from "~/components/vendor/profile/utils";

const GROUP_FORM_INITIAL_STATE = {
  tags: [],
  products: [],
  resources: [],
  newsworthy: [],
  visibility: "PRIVATE",
  awards: [],
};

interface INewVendorGroupProps {
  vendor: NonNullable<IVendorQuery["company"]>;
}

export default function NewVendorGroup({ vendor }: INewVendorGroupProps) {
  const intl = useIntl();
  const router = useRouter();

  const maxGroups = intl.formatMessage({
    defaultMessage: `You've reached the limit of groups for your plan`,
    id: "knb2lM",
  });
  const couldntSave = intl.formatMessage({
    defaultMessage: `Couldn't save. Please try again later!`,
    id: "R5RM9+",
  });

  return (
    <div>
      <Mutation<ICreateGroupMutation, ICreateGroupMutationVariables> mutation={CreateGroup}>
        {(createGroup) => (
          <GroupForm
            onSubmit={async (values) => {
              try {
                await createGroup({
                  variables: {
                    group: {
                      ...convertValuesToVariables(values),
                      vendor: vendor._id,
                    },
                  },
                  refetchQueries: refetchQueries(["Vendor", "CompanyAccountBillingInfo", "Selfie"]),
                  awaitRefetchQueries: true,
                }).then((mutationResult) => {
                  if (mutationResult && mutationResult.data && mutationResult.data.createGroup) {
                    router.push("/groups/[groupSlug]", `/groups/${mutationResult.data.createGroup.slug}`);
                  }
                });

                return null;
              } catch (e: any) {
                if (process.env.NODE_ENV === "development") {
                  throw e;
                }

                if (/Vendor plan doesn't support more groups/i.test(e.message)) {
                  return {
                    [FORM_ERROR]: maxGroups,
                  };
                }

                return {
                  [FORM_ERROR]: couldntSave,
                };
              }
            }}
            initialValues={GROUP_FORM_INITIAL_STATE}
          />
        )}
      </Mutation>
    </div>
  );
}
